<template>
  <b-modal
    id="export-requirements-modal"
    title="Export all requirements"
    name="export-requirements-modal"
    size="lg"
    :busy="loading"
    ref="exportrequirementsmodal"
    ok-title="Export"
    close-title="Cancel"
    hide-header-close
    :ok-disabled="!format"
    @ok="handleOk"
    @cancel="handleCancel">
    <b-row class="my-1">
      <b-col sm="3"><label for="field-formatOptions">Format:</label></b-col>
      <b-col sm="9">
        <b-form-select id="field-formatOptions" v-model="format" :options="formatOptions" class="mb-3"
                       data-vv-name="format" v-validate="'required'">
        </b-form-select>
      </b-col>
    </b-row>
    <div slot="modal-ok" v-if="loading">
      <icon name="spinner" pulse></icon> Exporting
    </div>
  </b-modal>
</template>

<script>
  import Papa from 'papaparse'
  import FileSaver from 'file-saver'
  import dayjs from 'dayjs'
  import utilsMixin from '@/mixins/utils'
  export default {
    computed: {
      currentProject () {
        return this.$store.state.currentProject
      }
    },
    data () {
      return {
        error: '',
        format: 'csv',
        formatOptions: [
          { value: 'csv', text: 'CSV' }
        ],
        loading: false
      }
    },
    mixins: [utilsMixin],
    methods: {
      clearModal () {
        this.error = ''
        this.format = 'csv'
      },
      handleCancel (e) {
        this.clearModal()
      },
      handleOk (e) {
        e.preventDefault()
        this.loading = true
        this.getRequirements()
      },
      generateCsv (data) {
        let csv = Papa.unparse(data)
        let blob = new Blob([csv], {type: 'text/csv;charset=utf-8'})
        FileSaver.saveAs(blob, `rmcloud-export-${dayjs().format()}.csv`)
        this.loading = false
        this.$refs.exportrequirementsmodal.hide()
      },
      getRequirements () {
        this.$http.get(
          `/api/requirement/export?atlassian_project_id=${this.currentProject.id}`
        ).then(response => {
          console.log('success')
          this.generateCsv(response.data)
        }, error => {
          this.loading = false
          let errorString = this.createErrorStringFromResponse(error.response.data)
          window.AP.flag.create({
            title: 'Error',
            body: `There was a problem exporting your requirements: ${errorString}`,
            type: 'error',
            close: 'auto'
          })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ExportRequirementsModal.vue?c39f1b3e